import { FileDown } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { downloadPdf } from "@/lib/pdf";

import { CashReportPdfDocument } from "./cash-report-pdf-document";

import type { CashEntry } from "@artisancode/api-types";

export function CashReportPdfButton({
  items,
  totalByMethod,
  grandTotal,
  dateFrom,
  dateTo,
  sourceLabel,
}: {
  items: CashEntry[];
  totalByMethod: Record<string, number>;
  grandTotal: number;
  dateFrom: string;
  dateTo: string;
  sourceLabel: string;
}) {
  const [isGenerating, setIsGenerating] = useState(false);
  const rangeMissing = !dateFrom || !dateTo;
  const disabled = rangeMissing || isGenerating;

  async function handleDownload() {
    if (rangeMissing) return;
    if (items.length === 0) {
      toast.error("Tidak ada data kas pada rentang tanggal ini.");
      return;
    }
    setIsGenerating(true);
    try {
      await downloadPdf(
        <CashReportPdfDocument
          items={items}
          totalByMethod={totalByMethod}
          grandTotal={grandTotal}
          periodStart={dateFrom}
          periodEnd={dateTo}
          sourceLabel={sourceLabel}
        />,
        `Kas-${dateFrom}-${dateTo}.pdf`,
      );
    } catch {
      toast.error("Gagal membuat PDF kas.");
    } finally {
      setIsGenerating(false);
    }
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span tabIndex={rangeMissing ? 0 : -1}>
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={handleDownload}
              disabled={disabled}
            >
              <FileDown className="mr-1.5 h-4 w-4" />
              {isGenerating ? "Membuat PDF..." : "Unduh PDF"}
            </Button>
          </span>
        </TooltipTrigger>
        {rangeMissing && (
          <TooltipContent>
            Pilih rentang tanggal dulu untuk mengaktifkan tombol ini
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
}
